module.exports = __webpack_public_path__ + "img/padlock.5f61602c.svg";